// Module
var code = "<svg viewBox=\"0 0 14 2\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M1.09279e-07 1C4.89257e-08 0.585786 0.335786 0.25 0.75 0.25L12.75 0.249998C13.1642 0.249998 13.5 0.585784 13.5 0.999998C13.5 1.41421 13.1642 1.75 12.75 1.75L0.75 1.75C0.335787 1.75 1.69631e-07 1.41421 1.09279e-07 1Z\"/> </svg> ";
// Exports
module.exports = code;